import React from 'react';

import './styles.css';
import nextButton from './assets/right.svg';
import prevButton from './assets/left.svg';

const PREVIOUS = 'previous';
const NEXT = 'next';

const DEFAULT_DIRECTION = NEXT;

const DIRECTIONS = {
  [PREVIOUS]: prevButton,
  [NEXT]: nextButton
};

const PaginatorButton = ({onClick, direction}) => {
  const icon = DIRECTIONS[direction] || DIRECTIONS[DEFAULT_DIRECTION];

  return (
    <div
      className="PaginatorButton colab-small-border-radius colab-clickable"
      onClick={onClick}>
      <img className="icon" src={icon} alt="" />
    </div>
  );
};

PaginatorButton.PREVIOUS = PREVIOUS;
PaginatorButton.NEXT = NEXT;

export default PaginatorButton;
